module.exports = __webpack_public_path__ + "72836adee96cd61f8af37149d9a12d2d.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/sehnsuchtslieder.jpg
// module id = 498
// module chunks = 0